import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Home } from "@mui/icons-material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from "@mui/material";
import { 
  fetchReferenceMaterialOnloadData,
  fetchAllReferenceMaterialsService
} from "../../services/referenceMaterialService";
import Loader from "../../components/Loader";
import { notifyError } from "../../utilities/helper";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

const ReferenceMaterial = () => {
  const [load, setLoad] = useState(false);
  const [typeOptions, setTypeOptions] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [materialsData, setMaterialsData] = useState([]);

  const access_token = localStorage?.getItem("access_token");
  const roleId = localStorage.getItem("roleId");
  const cultureCode = localStorage.getItem("currentUserCultureCode");

  useEffect(() => {
    getOnloadData();
  }, []);

  const getOnloadData = async () => {
    setLoad(true);
    try {
      const res = await fetchReferenceMaterialOnloadData(access_token, null, roleId, cultureCode);
      if (res?.status === 200) {
        setTypeOptions(res?.data?.result?.viewBagData?.referenceMaterialTypeSelectList || []);
      }
    } catch (err) {
      console.log(err.message);
    } finally {
      setLoad(false);
    }
  };

  const handleChange = (panelId) => async (event, isExpanded) => {
    setExpanded(isExpanded ? panelId : false);
    if (isExpanded) {
      // If expanding, fetch data if we haven't already
      if (materialsData.length === 0) {
        setLoad(true);
        try {
          const res = await fetchAllReferenceMaterialsService(1, 1000, access_token, "");
          if (res?.status === 200) {
            setMaterialsData(res?.data?.result || []);
          }
        } catch (err) {
          notifyError(err?.message || "Error fetching reference materials");
        } finally {
          setLoad(false);
        }
      }
    }
  };

  return (
    <div className="content-body">
      <div className="home-container">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/reference-materials">
            Reference Materials
          </Link>
          -{" "}
          <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
        </p>
        <Link className="bread-crumbs-link home-inner-container">
          Set as Home Page
          <span>
            <Home
              sx={{
                fontSize: "20px",
              }}
            />
          </span>
        </Link>
      </div>

      {load ? (
        <Loader />
      ) : (
        <Box sx={{ width: '100%', margin: '0 auto', marginTop: '30px', border: '1px solid #e0e0e0', borderRadius: '4px', p: 2 }}>
          {typeOptions.map((typeOption) => {
            // Filter materials for this specific type
            const items = materialsData.filter(m => m.referenceMaterialTypeId === typeOption.id);
            
            return (
              <Accordion 
                key={typeOption.id} 
                expanded={expanded === typeOption.id} 
                onChange={handleChange(typeOption.id)}
                sx={{ mb: 2, border: '1px solid #e0e0e0', boxShadow: 'none', borderRadius: '4px', '&:before': { display: 'none' } }}
              >
                <AccordionSummary
                  aria-controls={`panel-${typeOption.id}-content`}
                  id={`panel-${typeOption.id}-header`}
                  sx={{ backgroundColor: '#f5f5f5', borderRadius: '4px', '& .MuiAccordionSummary-content': { justifyContent: 'center' } }}
                >
                  <Typography sx={{ fontWeight: '500', color: '#333' }}>
                    {typeOption.name}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', padding: '0px' }}>
                  {expanded === typeOption.id && load ? (
                    <Typography sx={{ p: 2 }}>Loading...</Typography>
                  ) : items.length > 0 ? (
                    <Box sx={{ columnCount: 2, columnGap: '20px', padding: '15px 20px', width: '100%' }}>
                      {items.map(item => (
                        <div key={item.id} style={{ breakInside: 'avoid', marginBottom: '10px' }}>
                          <a 
                            href={item.fullPath || "#"}
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ color: '#00b0f0', textDecoration: 'none', fontSize: '14px' }}
                          >
                            {item.name}
                          </a>
                        </div>
                      ))}
                    </Box>
                  ) : (
                    <Typography sx={{ color: '#888', fontStyle: 'italic', padding: '15px 20px', borderTop: '1px solid #eee', fontSize: '14px' }}>
                      No reference materials found for this type.
                    </Typography>
                  )}
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Box>
      )}
    </div>
  );
};

export default ReferenceMaterial;
